// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"_3qSHy7Z4yGMySlOdfLjcM-","appName":"_24m0NfLvv2dCMjssz73ER9","newPostBtn":"_1J1e7HolvuEeXGu4JeixSK","btnContainer":"_1AorTZAODg2KaavqSg8bho"};